$(document).ready(function () {
  // Product card
  if ($(window).width() > 1024) {
    $('.product-card__card').each(function () {
      const $card = $(this)
      const $photos = $card.find('.product-card__photo')
      const photosCount = $photos.length

      if (photosCount <= 1) {
        $card.find('.product-card-progress').hide()
        return
      }

      const barWidth = 100 / photosCount
      $card.find('.product-card-progress__bar').css('width', `${barWidth}%`)

      $card.on('mousemove', function (e) {
        const offset = $card.offset()
        const width = $card.outerWidth()
        const x = e.pageX - offset.left

        const partWidth = width / photosCount
        const index = Math.min(Math.floor(x / partWidth), photosCount - 1)

        $card
          .find('.product-card__photo')
          .removeClass('is-active')
          .eq(index)
          .addClass('is-active')

        const leftPercent = index * barWidth
        $card.find('.product-card-progress__bar').css('left', `${leftPercent}%`)
      })

      $card.on('mouseleave', function () {
        $card
          .find('.product-card__photo')
          .removeClass('is-active')
          .eq(0)
          .addClass('is-active')

        $card.find('.product-card-progress__bar').css('left', '0%')
      })
    })
  }

  // Product card color
  $('.product-card__color').on('click', function () {
    $(this).addClass('is-active').siblings().removeClass('is-active')
  })

  // Product card slider
  $('.product-slider--variable-width .product-slider__items').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToScroll: 1,
    variableWidth: true,
  })

  // Product card slider
  $('.project-head__photos').slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: true,
          arrows: false,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
    ],
  })

  // Product card slider
  const objectHeight = {}

  $('.compare-item-propertie__value').each(function () {
    const index = $(this).closest('.compare-item-propertie').index()

    if (!objectHeight[index]) {
      objectHeight[index] = []
    }

    objectHeight[index].push($(this))
  })

  for (let index in objectHeight) {
    let maxHeight = 0

    objectHeight[index].forEach(($el) => {
      $el.css('height', 'auto')
    })

    objectHeight[index].forEach(($el) => {
      const height = $el.outerHeight()
      if (height > maxHeight) {
        maxHeight = height
      }
    })

    objectHeight[index].forEach(($el) => {
      $el.height(maxHeight)
    })
  }

  $('.compare-items__in').slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: true,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
        },
      },
    ],
  })

  // Collection slider
  $('.collection__illustrations').slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  })

  // Zoom
  if ($(window).width() > 1024) {
    $('[data-zoom-src]').zoom({ url: $(this).data('zoom-src') })
  }

  // Product gallery
  $('.product-gallery__item').on('click', function () {
    const $clicked = $(this)

    const $allItemsHorizontal = $(
      '.product-gallery__items--horizontal .product-gallery__item',
    )
    const $allItemsVertical = $(
      '.product-gallery__items--vertical .product-gallery__item',
    )

    const isModal = $clicked.closest('#modal-product').length > 0

    let index

    if (isModal) {
      index = $allItemsVertical.index($clicked)
    } else {
      index = $allItemsHorizontal.index($clicked)
    }

    $allItemsHorizontal.removeClass('is-active')
    $allItemsVertical.removeClass('is-active')

    $allItemsHorizontal.eq(index).addClass('is-active')
    $allItemsVertical.eq(index).addClass('is-active')

    const src = $clicked.is('img')
      ? $clicked.attr('src')
      : $clicked.find('img').attr('src')

    $('.product__l .product-gallery__preview img').not('.zoomImg').prop('src', src)
    $('.modal-product__r .product-gallery__preview img').not('.zoomImg').prop('src', src)

    if ($(window).width() > 1024) {
      $('[data-zoom-src]')
        .attr('data-zoom-src', src)
        .trigger('zoom.destroy')
        .zoom({ url: src })
    }

    if (!isModal) {
      $(document).trigger('product-gallery:changed')
    }
  })

  // Product options
  $('.product-options__list .product-options__item').on('click', function () {
    $('.product-options__item').removeClass('is-active')
    $(this).toggleClass('is-active')
  })

  // Product slider
  $('.product-slider--4 .product-slider__items').slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          variableWidth: true,
        },
      },
    ],
  })

  // Button on product page
  $('.btn-quantity').each(function () {
    const $quantity = $(this)
    const $input = $quantity.find('.btn-quantity__value')
    const $btnMinus = $quantity.find('.btn-quantity__control--minus')
    const $btnPlus = $quantity.find('.btn-quantity__control--plus')

    function updateMinusState(value) {
      if (value <= 0) {
        $btnMinus.addClass('is-disabled')
      } else {
        $btnMinus.removeClass('is-disabled')
      }
    }

    updateMinusState(parseInt($input.val(), 10))

    $btnPlus.on('click', function () {
      let currentValue = parseInt($input.val(), 10) || 0
      currentValue += 1
      $input.val(currentValue)
      updateMinusState(currentValue)
    })

    $btnMinus.on('click', function () {
      let currentValue = parseInt($input.val(), 10) || 0
      if (currentValue > 0) {
        currentValue -= 1
        $input.val(currentValue)
        updateMinusState(currentValue)
      }
    })
  })

  // Product card slider
  $('.intro__items').slick({
    dots: false,
    arrows: false,
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
  })

  setTimeout(function () {
    $('#bestsellers').addClass('in active')
  }, 200)

  // Range
  $('.range').each(function () {
    const $range = $(this)
    const $visual = $range.find('.range__visual')

    const $fromInput = $range.find('.range__input-value--from')
    const $toInput = $range.find('.range__input-value--to')

    $fromInput.after(
      '<input type="hidden" class="range__input-value--from-hidden" />',
    )
    $toInput.after(
      '<input type="hidden" class="range__input-value--to-hidden" />',
    )

    const $fromHidden = $range.find('.range__input-value--from-hidden')
    const $toHidden = $range.find('.range__input-value--to-hidden')

    const min = parseInt($range.attr('data-min'), 10)
    const max = parseInt($range.attr('data-max'), 10)
    const from = parseInt($range.attr('data-from'), 10)
    const to = max

    const currencySign = ' ₽'

    function formatNumber(value) {
      return (
        value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + currencySign
      )
    }

    function cleanNumber(str) {
      if (!str) return 0
      return parseInt(str.toString().replace(/\s+/g, '').replace(/\D/g, ''), 10)
    }

    function setInputs(fromVal, toVal) {
      $fromInput.val(formatNumber(fromVal))
      $fromHidden.val(fromVal)

      $toInput.val(formatNumber(toVal))
      $toHidden.val(toVal)
    }

    setInputs(from, to)

    const sliderInstance = $visual
      .ionRangeSlider({
        min: min,
        max: max,
        from: from,
        to: to,
        step: 1000,
        type: 'double',
        hide_from_to: true,
        hide_min_max: true,
        onStart: updateInputs,
        onChange: updateInputs,
      })
      .data('ionRangeSlider')

    function updateInputs(data) {
      setInputs(data.from, data.to)
    }

    function handleInput($input, $hiddenInput, isFromField) {
      const input = $input[0]
      const cursorPos = input.selectionStart

      const currentText = $input.val()
      const hasCurrency = currentText.indexOf(currencySign) > -1

      const cleanText = currentText.replace(currencySign, '')

      let value = cleanNumber(cleanText)

      const formattedValue = formatNumber(value)

      const spacesBeforeCursor = (
        cleanText.substring(0, cursorPos).match(/\s/g) || []
      ).length

      const valueStr = value.toString()
      const spacesInFormattedValue = Math.floor((valueStr.length - 1) / 3)

      let newCursorPos

      if (cursorPos >= cleanText.length) {
        newCursorPos = formattedValue.length - currencySign.length
      } else {
        const digitsBeforeCursor = cleanText
          .substring(0, cursorPos)
          .replace(/\s/g, '').length

        const spacesInNewFormat = Math.floor(digitsBeforeCursor / 3)
        newCursorPos = digitsBeforeCursor + spacesInNewFormat
      }

      $input.val(formattedValue)

      setTimeout(function () {
        input.setSelectionRange(newCursorPos, newCursorPos)
      }, 0)

      $hiddenInput.val(value)

      let fromVal = parseInt($fromHidden.val())
      let toVal = parseInt($toHidden.val())

      if (isFromField) {
        fromVal = isNaN(fromVal) ? min : Math.max(min, Math.min(fromVal, toVal))
        $fromHidden.val(fromVal)
      } else {
        toVal = isNaN(toVal) ? max : Math.min(max, Math.max(fromVal, toVal))
        $toHidden.val(toVal)
      }

      sliderInstance.update({
        from: fromVal,
        to: toVal,
      })
    }

    $fromInput.on('input', function () {
      handleInput($(this), $fromHidden, true)
    })

    $toInput.on('input', function () {
      handleInput($(this), $toHidden, false)
    })

    $fromInput.add($toInput).on('click', function () {
      const $this = $(this)
      const value = $this.val()
      const currPos = this.selectionStart

      if (currPos > value.length - currencySign.length) {
        setTimeout(() => {
          this.setSelectionRange(
            value.length - currencySign.length,
            value.length - currencySign.length,
          )
        }, 0)
      }
    })
  })

  $('select').styler()

  // Filter
  $('.filter .btn').on('click', function (e) {
    $('.filter').removeClass('is-active')
    $(this).closest('.filter').toggleClass('is-active')

    e.stopPropagation()
  })

  // Info page
  if ($('[data-anchors-headers="true"]').length > 0) {
    const $sidebar = $('.info-page-nav')

    let $headings = $('[data-anchors-headers="true"] .h3')

    if (
      $('[data-anchors-headers="true"] .maintenance-body-item__headline')
        .length > 0
    ) {
      $headings = $(
        '[data-anchors-headers="true"] .maintenance-body-item__headline',
      )
    }

    const $header = $('header')
    const headerHeight = $header.outerHeight() || 0

    $sidebar.empty()

    $headings.each(function (index) {
      const $heading = $(this)
      const text = $heading.text().trim()
      const id = 'section-' + index
      $heading.attr('id', id)

      const $li = $('<li>').addClass('info-page-nav__item')
      const $a = $('<a>')
        .attr('href', '#' + id)
        .addClass('info-page-nav__link')
        .text(text)

      $li.append($a)
      $sidebar.append($li)
    })

    $('.info-page-nav').on('click', '.info-page-nav__link', function (e) {
      e.preventDefault()
      const targetId = $(this).attr('href')
      const $target = $(targetId)

      if ($target.length) {
        $('html, body').animate(
          {
            scrollTop: $target.offset().top - headerHeight - 10,
          },
          500,
        )
      }
    })

    const $links = $('.info-page-nav__link')

    function highlightCurrentSection() {
      let scrollPos = $(window).scrollTop()
      let currentId = null

      $headings.each(function () {
        const $section = $(this)
        const top = $section.offset().top - headerHeight - 20

        if (scrollPos >= top) {
          currentId = $section.attr('id')
        }
      })

      if (currentId) {
        $links.removeClass('is-active')
        $links.filter('[href="#' + currentId + '"]').addClass('is-active')
      }
    }

    $(window).on('scroll', highlightCurrentSection)
    highlightCurrentSection()
  }

  // Map
  if ($('#map').length > 0) {
    ymaps.ready(function () {
      var myMap = new ymaps.Map('map', {
        center: [55.649936, 37.440568],
        zoom: 16,
      })

      var myPlacemark = new ymaps.Placemark([55.649936, 37.440568], {
        hintContent: 'Офис',
        balloonContent:
          '<strong>Наш офис</strong><br>г. Москва, поселение Московский, МКАД 47-й км, д. 3, стр. 3',
      })

      myMap.geoObjects.add(myPlacemark)
    })
  }

  // Submenu
  $('[data-submenu-show]').on('mouseover', function () {
    const submenuId = $(this).attr('data-submenu-show')
    const $submenuElement = $(`[data-submenu-id="${submenuId}"]`)

    if ($submenuElement.length) {
      $submenuElement.addClass('is-active')
    }
  })

  $('[data-submenu-id]').on('mouseleave', function () {
    $(this).removeClass('is-active')
  })

  $('.header-nav__link')
    .not('[data-submenu-show]')
    .on('mousemove', function () {
      $('[data-submenu-id]').removeClass('is-active')
    })

  if ($('.product__in').length > 0) {
    const $product = $('.product__in')
    const $productInfo = $('.product-info')
    if (!$product.length) return

    function checkFullyScrolled() {
      const rect = $product[0].getBoundingClientRect()

      const isFullyScrolled = rect.bottom <= 0

      $productInfo.toggleClass('is-active', isFullyScrolled)
    }

    $(window).on('scroll resize', checkFullyScrolled).trigger('scroll')
  }

  // BURGER
  $('.btn--burger').on('click', function () {
    $(this).toggleClass('is-active')
    $('body').toggleClass('menu-open')
    $('html').toggleClass('is-ovh')
    $('.menu').toggleClass('is-active')
  })

  $('[data-mobile-menu-show]').on('click', function (e) {
    e.preventDefault()

    const submenuId = $(this).attr('data-mobile-menu-show')

    $('[data-submenu-mobile="' + submenuId + '"]').addClass('is-active')
  })

  $('.btn--menu-back').on('click', function (e) {
    e.preventDefault()

    $('[data-submenu-mobile]').removeClass('is-active')

    $('[data-main-mobile-menu]').addClass('is-active')
  })

  $('.inp-group--search input').on('input', function () {
    if ($(this).val().length > 0) {
      $(this).addClass('is-active')
    } else {
      $(this).removeClass('is-active')
    }
  })

  $('.btn-search-reset').on('click', function () {
    const $parent = $(this).closest('.inp-group--search')
    const $input = $parent.find('input')

    $input.val('').removeClass('is-active')
  })

  $('.btn--search-black').on('click', function () {
    $('.search-popup').toggleClass('is-active')
    $('.search-popup-bg').toggleClass('is-active')
    $('html').toggleClass('is-ovh')
  })

  $('.search-popup-bg').on('click', function () {
    $('.search-popup').removeClass('is-active')
    $('.search-popup-bg').removeClass('is-active')
  })

  // Product gallery (preview arrows + thumb grouping + swipe)
  ;(function () {
    const $gallery = $('.product__l .product-gallery')
    if (!$gallery.length) return

    const $preview = $gallery.find('.product-gallery__preview')
    const $prevBtn = $gallery.find('.product-gallery__nav--prev')
    const $nextBtn = $gallery.find('.product-gallery__nav--next')
    const $thumbsPrev = $gallery.find('.product-gallery__thumbs-nav--prev')
    const $thumbsNext = $gallery.find('.product-gallery__thumbs-nav--next')
    const $itemsContainer = $gallery.find('.product-gallery__items--horizontal')

    function getHorizontalItems() {
      return $itemsContainer.find('.product-gallery__item')
    }

    function getVerticalItems() {
      return $('.product-gallery__items--vertical .product-gallery__item')
    }

    function getCurrentIndex() {
      const $items = getHorizontalItems()
      const idx = $items.index($items.filter('.is-active'))
      return idx < 0 ? 0 : idx
    }

    function goToSlide(index) {
      const $items = getHorizontalItems()
      const $verticalItems = getVerticalItems()
      const total = $items.length
      if (total === 0) return
      if (index < 0) index = 0
      if (index >= total) index = total - 1

      $items.removeClass('is-active')
      $verticalItems.removeClass('is-active')
      $items.eq(index).addClass('is-active')
      $verticalItems.eq(index).addClass('is-active')

      const src = $items.eq(index).find('img').attr('src')

      $('.product__l .product-gallery__preview img').not('.zoomImg').prop('src', src)
      $('.modal-product__r .product-gallery__preview img').not('.zoomImg').prop('src', src)

      if ($(window).width() > 1024) {
        $('[data-zoom-src]')
          .attr('data-zoom-src', src)
          .trigger('zoom.destroy')
          .zoom({ url: src })
      }

      updateNavState()
      ensureGroupVisibleFor(index)
    }

    function updateNavState() {
      const $items = getHorizontalItems()
      const total = $items.length
      const idx = getCurrentIndex()

      $prevBtn.toggleClass('is-hidden', total <= 1 || idx <= 0)
      $nextBtn.toggleClass('is-hidden', total <= 1 || idx >= total - 1)
    }

    // ----- thumb grouping -----
    let currentGroup = 0
    let groupSize = 1

    function computeGroupSize() {
      const $items = getHorizontalItems()
      if (!$items.length) return 1

      const $first = $items.eq(0)
      const itemW = $first.outerWidth() || 1
      const styleGap = parseFloat($itemsContainer.css('gap')) || 0
      const containerW = $itemsContainer.innerWidth() || 0

      const fits = Math.max(
        1,
        Math.floor((containerW + styleGap) / (itemW + styleGap)),
      )
      return fits
    }

    function totalGroups() {
      const total = getHorizontalItems().length
      return Math.max(1, Math.ceil(total / groupSize))
    }

    function applyGroup() {
      const $items = getHorizontalItems()
      const total = $items.length
      const groups = totalGroups()

      if (currentGroup < 0) currentGroup = 0
      if (currentGroup >= groups) currentGroup = groups - 1

      const start = currentGroup * groupSize
      const end = Math.min(total, start + groupSize)

      $items.each(function (i) {
        $(this).toggleClass('is-hidden', i < start || i >= end)
      })

      const showThumbNav = groups > 1
      $thumbsPrev.toggleClass('is-removed', !showThumbNav)
      $thumbsNext.toggleClass('is-removed', !showThumbNav)
      $thumbsPrev.toggleClass('is-hidden', showThumbNav && currentGroup <= 0)
      $thumbsNext.toggleClass(
        'is-hidden',
        showThumbNav && currentGroup >= groups - 1,
      )
    }

    function ensureGroupVisibleFor(index) {
      if (groupSize < 1) return
      const target = Math.floor(index / groupSize)
      if (target !== currentGroup) {
        currentGroup = target
        applyGroup()
      }
    }

    function recalc() {
      // temporarily reveal all to measure
      const $items = getHorizontalItems()
      $items.removeClass('is-hidden')
      groupSize = computeGroupSize()
      const idx = getCurrentIndex()
      currentGroup = Math.floor(idx / groupSize)
      applyGroup()
    }

    $prevBtn.on('click', function (e) {
      e.stopPropagation()
      e.preventDefault()
      goToSlide(getCurrentIndex() - 1)
    })

    $nextBtn.on('click', function (e) {
      e.stopPropagation()
      e.preventDefault()
      goToSlide(getCurrentIndex() + 1)
    })

    $thumbsPrev.on('click', function (e) {
      e.stopPropagation()
      e.preventDefault()
      if (currentGroup > 0) {
        currentGroup -= 1
        applyGroup()
      }
    })

    $thumbsNext.on('click', function (e) {
      e.stopPropagation()
      e.preventDefault()
      if (currentGroup < totalGroups() - 1) {
        currentGroup += 1
        applyGroup()
      }
    })

    // swipe on preview
    let touchStartX = 0
    let touchEndX = 0
    const minSwipeDistance = 50

    $preview.on('touchstart', function (e) {
      touchStartX = e.originalEvent.touches[0].clientX
    })

    $preview.on('touchend', function (e) {
      touchEndX = e.originalEvent.changedTouches[0].clientX
      const diff = touchStartX - touchEndX
      if (Math.abs(diff) < minSwipeDistance) return
      const currentIndex = getCurrentIndex()
      goToSlide(diff > 0 ? currentIndex + 1 : currentIndex - 1)
    })

    // sync when thumbnail clicked elsewhere (existing handler)
    $(document).on('product-gallery:changed', function () {
      updateNavState()
      ensureGroupVisibleFor(getCurrentIndex())
    })

    let resizeTimer
    $(window).on('resize', function () {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(recalc, 150)
    })

    recalc()
    updateNavState()
  })()
})

$(document).on('click', function (e) {
  if (!$(e.target).closest('.filter').length) {
    $('.filter').removeClass('is-active')
  }
})
